import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { useClickAway } from 'react-use';
import Link from 'components/consumer/Link';
import MenuButton from 'components/consumer/menu-button';
import IconUserAccount from 'components/icons/iconUserAccount';
import IconSearch from 'components/icons/IconSearch';
import IconMapMarker from 'components/icons/IconMapMarker';
import LogoLink from 'components/consumer/LogoLink';
import { colorGrayLight1 } from 'styles/layout/colors';
import avo from 'analytics/avo';
import MobileNavbarModalUI from 'components/nav/MobileNavbarModal/MobileNavbarModalUI';
import MobileNavbarShowroomLocator from 'components/nav/shared/HeaderToolbar/MobileNavbarShowroomLocator';
import IcCart from './ic-cart';
import InstantSearchMobile from '../consumer-search/instant-search/InstantSearchMobile';
import BrowserOnly from '../BrowserOnly';
const ConsumerHeaderMobile = () => {
  const $ = _c(45);
  const targetElement = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileSearchBarOpen, setIsMobileSearchBarOpen] = useState(false);
  const [isShowroomLocatorOpen, setIsShowroomLocatorOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const showroomDropdownRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = t1 => {
      const {
        searchQuery: updatedSearchQuery,
        currentPage: updatedCurrentPage
      } = t1;
      setSearchQuery(updatedSearchQuery);
      setCurrentPage(updatedCurrentPage);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setSearchEventParams = t0;
  let t1;
  if ($[1] !== currentPage || $[2] !== isMenuOpen || $[3] !== searchQuery) {
    t1 = () => {
      if (isMenuOpen === true && searchQuery?.length > 1 && currentPage) {
        avo.productsSearched({
          query: searchQuery,
          location: currentPage,
          searchTarget: avo.SearchTarget.EXIT_SEARCH
        });
      }
    };
    $[1] = currentPage;
    $[2] = isMenuOpen;
    $[3] = searchQuery;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const logSearchToAvo = t1;
  let t2;
  if ($[5] !== logSearchToAvo) {
    t2 = () => {
      logSearchToAvo();
      setIsMenuOpen(_temp);
    };
    $[5] = logSearchToAvo;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const toggleMenu = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsShowroomLocatorOpen(false);
      setIsMobileSearchBarOpen(_temp2);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const toggleSearchBar = t3;
  let t4;
  if ($[8] !== logSearchToAvo) {
    t4 = () => {
      logSearchToAvo();
      setIsMenuOpen(false);
      setSearchQuery(null);
      setCurrentPage(null);
    };
    $[8] = logSearchToAvo;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const closeMenu = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsMobileSearchBarOpen(false);
      setIsShowroomLocatorOpen(_temp3);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const toggleShowroomLocator = t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsShowroomLocatorOpen(false);
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const closeShowroomLocator = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      if (event.target instanceof Element && event.target.closest("a")) {
        setIsShowroomLocatorOpen(false);
      }
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleShowroomLocatorClick = t7;
  useClickAway(showroomDropdownRef, closeShowroomLocator);
  let t8;
  if ($[13] !== isMenuOpen) {
    t8 = classNames("h-[3.75rem] w-full hidden z-[998] [-webkit-tap-highlight-color:transparent] max-[1023px]:[transition:transform_1s_ease-in] max-[1023px]:block", "[&_a]:no-underline [&_a]:text-gray", {
      expanded: isMenuOpen
    });
    $[13] = isMenuOpen;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isMenuOpen || $[16] !== toggleMenu) {
    t9 = <div className="items-center flex h-full justify-center left-0 absolute top-0 w-[60px] rounded-[2rem] z-[1] hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7"><MenuButton onClick={toggleMenu} open={isMenuOpen} /></div>;
    $[15] = isMenuOpen;
    $[16] = toggleMenu;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <LogoLink className="hover:bg-gray-light7" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="cursor-pointer bg-white rounded-[2rem] box-border w-12 h-12 flex justify-center items-center relative hover:z-10 active:z-10 focus-within:z-10 hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7 [&_a]:flex"><button data-xc="search" title="Search" className="[background:none] border-0 focus-visible:outline-offset-4" type="button" onClick={toggleSearchBar}><IconSearch color={colorGrayLight1} height="17" width="17" /></button></div>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="cursor-pointer bg-white rounded-[2rem] box-border w-12 h-12 flex justify-center items-center relative hover:z-10 active:z-10 focus-within:z-10 hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7 [&_a]:flex"><button type="button" onClick={toggleShowroomLocator} className="[background:none] border-0 focus-visible:outline-offset-4" title="Showrooms"><IconMapMarker color={colorGrayLight1} height="19" width="19" className="[&_svg_path]:!stroke-[1]" /></button></div>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isShowroomLocatorOpen) {
    t13 = isShowroomLocatorOpen && <div className="absolute top-full -right-16 mt-1 bg-white border border-gray-light5 z-[1000]" onClick={handleShowroomLocatorClick}><MobileNavbarShowroomLocator onClose={() => setIsShowroomLocatorOpen(false)} /></div>;
    $[21] = isShowroomLocatorOpen;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <div ref={showroomDropdownRef} className="relative">{t12}{t13}</div>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="cursor-pointer bg-white rounded-[2rem] box-border w-12 h-12 flex justify-center items-center relative hover:z-10 active:z-10 focus-within:z-10 hover:bg-gray-light7 active:bg-gray-light7 focus-visible:bg-gray-light7 [&_a]:flex"><Link to="/customer/dashboard/" className="[background:none] border-0 focus-visible:outline-offset-4"><IconUserAccount /></Link></div>;
    t16 = <IcCart isMobile={true} isFixedTopNav={true} />;
    $[25] = t15;
    $[26] = t16;
  } else {
    t15 = $[25];
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14) {
    t17 = <div className="absolute right-5 flex items-center justify-end -space-x-3">{t11}{t14}{t15}{t16}</div>;
    $[27] = t14;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t17 || $[30] !== t9) {
    t18 = <div className="relative items-center justify-center h-[3.75rem] w-full px-[3.333vw] py-0 z-[999] max-[1023px]:bg-white max-[1023px]:flex max-[1023px]:[transition:transform_.25s_ease-in-out,background-color_.25s_ease-in-out] max-[1023px]:px-5 max-[1023px]:py-0 hover:max-[1023px]:[border-bottom:none]">{t9}{t10}{t17}</div>;
    $[29] = t17;
    $[30] = t9;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== closeMenu || $[33] !== isMobileSearchBarOpen) {
    t19 = isMobileSearchBarOpen && <div className="relative items-center justify-center h-[3.75rem] w-full z-[999] max-[1023px]:bg-white max-[1023px]:[transition:transform_.25s_ease-in-out,background-color_.25s_ease-in-out]"><InstantSearchMobile placeholder="Search Joybird" toggleMenu={closeMenu} setSearchEventParams={setSearchEventParams} variant="consumer-header-mobile" toggleMobileSearchBar={toggleSearchBar} /></div>;
    $[32] = closeMenu;
    $[33] = isMobileSearchBarOpen;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19) {
    t20 = <BrowserOnly>{t19}</BrowserOnly>;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== closeMenu || $[38] !== isMenuOpen) {
    t21 = <BrowserOnly><MobileNavbarModalUI isOpen={isMenuOpen} onClose={closeMenu} /></BrowserOnly>;
    $[37] = closeMenu;
    $[38] = isMenuOpen;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t20 || $[42] !== t21 || $[43] !== t8) {
    t22 = <div className={t8} ref={targetElement}>{t18}{t20}{t21}</div>;
    $[40] = t18;
    $[41] = t20;
    $[42] = t21;
    $[43] = t8;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  return t22;
};
export default ConsumerHeaderMobile;
function _temp(prevMenu) {
  return !prevMenu;
}
function _temp2(prevVal) {
  return !prevVal;
}
function _temp3(prev) {
  return !prev;
}